import { render, staticRenderFns } from "./ChatGPTEditorTools.vue?vue&type=template&id=036920ec&"
import script from "./ChatGPTEditorTools.vue?vue&type=script&lang=js&"
export * from "./ChatGPTEditorTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports